import styles from "./TempNode.module.css";
import { DefaultNodeIcon } from "../../../DiagrammingToolbar/DefaultNodeIcon";
import { Colors } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import { SelectableNodeTypes } from "@zapier/canvas-state";
import { PathNodeIcon } from "../../../icons/PathNodeIcon";

function useNodeIcon(type: SelectableNodeTypes) {
  switch (type) {
    case "path":
      return <PathNodeIcon />;

    case "text":
      return <Icon name="formText" color="UiPrimaryStrongest" size={30} />;

    case "zap":
      return <Icon size={28} color="BrandOrange" name="miscBoltAlt" />;

    case "table":
      return <Icon size={28} color="BrandOrange" name="navTables" />;

    case "interface":
      return <Icon size={28} color="BrandOrange" name="navInterfaces" />;

    case "chatbots":
      return <Icon size={28} color="BrandOrange" name="navAIChatbot" />;

    case "embed":
      return <Icon size={30} name="statusPlaying" color="UiPrimaryStrongest" />;

    default:
      return <DefaultNodeIcon color={Colors.UiPrimaryStrongest} />;
  }
}

type Props = {
  data: {
    type: SelectableNodeTypes;
  };
};

export default function TempNode({ data: { type } }: Props) {
  const icon = useNodeIcon(type);

  return <div className={styles.tempNode}>{icon}</div>;
}
